var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1547",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1547h-2048z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1547h-2048zm412 412-16 2-16 8-12 9-8 9-9 16-4 13-1 7v950l3 17 4 11 7 11 9 10 11 9 10 5 15 4 7 1h1519l16-3 16-8 11-9 9-11 8-16 3-12 1-7v-953l-4-17-7-14-8-10-7-7-11-7-11-5-11-2-18-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,52)",
    d: "m0 0h1496l16 1 16 4 11 6 10 8 7 7 9 14 4 11 2 9 1 10v129l-5 2h-1641l-3-1v-136l5-19 8-14 9-10 10-9 10-6 13-4 4-1z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,567)",
    d: "m0 0h242v566l-4 1h-173l-15-2-14-6-11-8-8-8-9-14-5-12-3-14-1-65-1-134v-83l1-135z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1424,1010)",
    d: "m0 0h27l25 4 19 7 21 11 12 9 14 12 7 8 4 1 17-17 13-10 13-8 21-10 14-4 19-3h27l24 4 21 8 15 8 14 10 10 9 10 10 11 16 9 16 7 19 4 16 1 8v34l-3 16-6 20-11 21-9 13-9 10-9 9-14 10-13 8-16 7-20 6-29 4-17-1-23-5-16-6-16-8-20-14-9-7-9-12-3-1-12 14-13 10-20 13-18 8-21 6-11 2h-26l-23-4-17-5-16-7-17-11-10-8-7-6-7-8-10-13-9-16-5-11-6-20-3-19v-23l2-16 6-22 6-14 9-15 8-11 9-10 4-5 11-9 15-10 15-8 17-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1649)",
    d: "m0 0h399v468l-2-1-8-29-8-16-7-11-7-9-7-8-11-9-10-7-15-8-18-6-21-3-26-1h-150l-4-1-1-4-1-232-2-21-6-23-9-19-9-13-9-10-8-8-15-10-17-9-15-5-13-4z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1081)",
    d: "m0 0 2 3 5 19 11 23 10 14 11 12 13 11 16 10 16 7 19 4 21 2 168 1 2 1 1 235 2 20 5 21 8 18 9 14 11 13 10 9 14 9 13 8 18 6 15 4 2 2h-402z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,1046)",
    d: "m0 0h635l6 3 8 8 5 9 2 6v13l-4 9-6 8-10 6-7 2-16 1h-600l-15-2-10-6-7-9-4-10v-12l4-11 7-8 8-6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(546,1191)",
    d: "m0 0h470l12 2 9 6 8 11 3 10v7l-4 11-7 9-7 6-7 2-53 1h-415l-14-2-8-4-8-8-5-10-1-4v-9l4-11 6-8 6-5 6-3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,832)",
    d: "m0 0h343l2 2-1 20-3 12-7 13-11 12-9 6-16 4-8 1-166 1h-34l-37-1-16-3-14-7-11-11-7-11-4-10-1-6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,614)",
    d: "m0 0h204l29 1 9 2 11 6 9 8 7 10 6 12 2 8v21l-4 1h-336l-4-1-1-7 2-20 8-17 10-11 14-9 12-3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,698)",
    d: "m0 0h108v118l-1 1h-107z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,698)",
    d: "m0 0h108v119h-108z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,698)",
    d: "m0 0h94v119h-95v-118z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,1437)",
    d: "m0 0h1v110h-106l4-3 17-5 14-6 18-11 13-10 9-9 11-15 11-23 7-24z",
    fill: "#FEFEFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h106l-2 2-20 6-16 7-11 6-16 12-12 12-7 10-12 23-5 15-3 11-1 7h-1z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.a029bc17c629ced85da435fbdee1eb4c.svg";
export { ForwardRef as ReactComponent };